module.exports = __webpack_public_path__ + "media/02.15eadcb2.mp4";